import {alias, createModelSchema, custom, deserialize, serialize, list, object, SKIP} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";
import {MapKindLiteModel} from "@/modules/mutils/models/MapKindLiteModel";

export class MapSaveAction extends BaseObject {

    static ACTIONS = new Map([
      [0, 'NONE'],
      [1, 'REMOVE'],
      [2, 'REMOVE_COMPLETELY'],
      [3, 'RESTORE']
    ]);

    constructor() {
        super();
        this._action = 0;
        this._maps  = [];
        this._key = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get action() {
        return this._action;
    }
    set action(value) {
        this._action = value;
    }

    get maps() {
        return this._maps;
    }
    set maps(value) {
        this._maps = value;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new MapSaveAction());
        } else if (target instanceof MapSaveAction) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(MapSaveAction, v) : SKIP;
        }, (v) => {
            return deserialize(MapSaveAction, v);
        });
    }
}

createModelSchema(MapSaveAction, {
    _key: alias("key", Schema.primitive()),
    _action: alias("action", Schema.primitive()),
    _maps: alias("maps", list(MapKindLiteModel.schema())),
});